import * as types from '../types'
import axios from 'axios'
import router from '../../router'

const state = {
  loadingQuotationDetails: false,
  confirmingOrder: false,
  validatingOrder: false,
  validatingOrderError: false,
  detailsBusy: false,
  detailsStatus: null,
  quotationDetails: {
    orderId: null,
    createdAt: null,
    deliveryAddress: {
      name: null,
      address: null,
      postcode: null,
      city: null
    },
    deliveryDate: null,
    deliveryDateFirst: null,
    deliverDateLast: null,
    closingDays: []
  },
  confirmationDetails: {
    orderId: null,
    email: null,
    orderDate: null,
    deliveryDate: null
  },
  serverTime: null
}

const getters = {
  loadingQuotationDetails: (state) => {
    return state.loadingQuotationDetails
  },
  quotationDetails: (state) => {
    return state.quotationDetails
  },
  confirmingOrder: (state) => {
    return state.confirmingOrder
  },
  validatingOrder: (state) => {
    return state.validatingOrder
  },
  validatingOrderError: (state) => {
    return state.validatingOrderError
  },
  createdAt: (state) => {
    return state.quotationDetails.createdAt
  },
  deliveryDate: (state) => {
    return state.quotationDetails.deliveryDate
  },
  deliveryAddress: (state) => {
    return state.quotationDetails.deliveryAddress
  },
  confirmationDetails: (state) => {
    return state.confirmationDetails
  },
  serverTime: (state) => {
    return state.serverTime
  }
}

const mutations = {
  [types.MUTATE_LOADING_QUOTATION_DETAILS]: (state, loadingQuotationDetails) => {
    state.loadingQuotationDetails = loadingQuotationDetails
  },
  [types.MUTATE_CONFIRMING_ORDER]: (state, confirmingOrder) => {
    state.confirmingOrder = confirmingOrder
  },
  [types.MUTATE_VALIDATING_ORDER]: (state, validatingOrder) => {
    state.validatingOrder = validatingOrder
  },
  [types.MUTATE_VALIDATING_ORDER_ERROR]: (state, validatingOrderError) => {
    state.validatingOrderError = validatingOrderError
  },
  [types.MUTATE_DELIVERY_DATE]: (state, deliveryDate) => {
    state.quotationDetails.deliveryDate = deliveryDate
  },
  [types.MUTATE_DELIVERY_ADDRESS]: (state, deliveryAddress) => {
    state.quotationDetails.deliveryAddress = deliveryAddress
  },
  [types.MUTATE_QUOTATION_DETAILS]: (state, quotationDetails) => {
    state.quotationDetails = quotationDetails
  },
  [types.MUTATE_CONFIRMATION_DETAILS]: (state, confirmationDetails) => {
    state.confirmationDetails = confirmationDetails
  },
  [types.MUTATE_SERVERTIME]: (state, serverTime) => {
    state.serverTime = serverTime
  }
}

const actions = {
  [types.ORDER_LOAD_CART_FROM_LOCAL_STORAGE]: ({ commit }) => {
    // Also store the cart in the localStorage
    let cart = JSON.parse(localStorage.getItem('cart'))
    commit(types.MUTATE_CART, cart)
  },
  [types.FETCH_QUOTATION_DETAILS]: ({ commit, state, dispatch }, quotationId) => {
    commit(types.MUTATE_LOADING_QUOTATION_DETAILS, true)

    axios
      .get('/quotation/details/' + quotationId)
      .then(res => {
        commit(types.MUTATE_QUOTATION_DETAILS, res.data)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_LOADING_QUOTATION_DETAILS, false)
      })
  },
  [types.UPDATE_DELIVERY_DETAILS]: ({ commit, state, dispatch }, deliveryAddress) => {
    commit(types.MUTATE_DELIVERY_ADDRESS, {
      name: state.quotationDetails.deliveryAddress.name,
      ...deliveryAddress
    })
  },
  [types.CONFIRM_ORDER]: ({ commit, dispatch, state, rootState }) => {
    commit(types.MUTATE_CONFIRMING_ORDER, true)

    axios
      .post('/quotation/order', {
        cart: rootState.tool.cart,
        address: state.quotationDetails.deliveryAddress,
        date: state.quotationDetails.deliveryDate
      })
      .then(res => {
        commit(types.MUTATE_CONFIRMATION_DETAILS, res.data)
        // Redirect to confirmation page
        router.push({ name: 'confirmation' })
      })
      .catch(error => {
        // Log error
        console.log(error)
      })
      .finally(() => {
        commit(types.MUTATE_CONFIRMING_ORDER, false)
        dispatch(types.RESET_CART)
      })
  },
  [types.FETCH_SERVERTIME]: ({ commit, state, dispatch }, quotationId) => {
    axios
      .get('/quotation/time')
      .then(res => {
        commit(types.MUTATE_SERVERTIME, res.data.serverTime)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
